export default {
    fields: {
        mapping_id: {type:'primary'},
        net_id: {type:'hidden'},
        from_type: {type:'hidden'},
        username: {title: '客户号',width:140},
        nickname: {title: '备注(姓名)',width:140},
        old_nickname: {title: '原用户',width:140},
        phone: {title: '客户号',width:140},
        start_time: {title: '开始时间', type: 'daterange'},
        change_time: {title: '首次修改用户时间', type: 'daterange'},
        end_time: {title: '截止时间', type: 'daterange'},
        free_sum: {title: '已免费授权次数'},
        level: {title: '会员等级', type: 'dict_key', dict_key: 'pro_member_level',width:80},
        type:{title:'操作类型',type:'dict_key',dict_key:'pro_log_type'},
        create_time: {title: '添加时间', type: 'date', format: 'Y-m-d H:i:s'},
        company_name:{title:'购买公司名称'},
        is_default:{title:'是否默认',type:'dict_key',dict_key:'is_yes_or_no',width:90,info_text:'如果用户加入了多个网络版，设置哪个优先使用'},
        bind_status:{title:'用户状态',type:'slot',slot:'bindstatus',width:90},
        company_name_alias:{title:'公司名'},
    },
    rules: {
        phone: [
            {required: true, message: '手机号不可以为空', trigger: 'blur'},
        ],
    },
    group: {
        show_buy: {
            fields: ['nickname', {name:'username',title:'客户号'}, 'create_time', 'bind_status','change_time'],
        },
        show_join: {
            fields: ['company_name_alias','nickname', 'phone',  'is_default','bind_status','create_time'],
        },
        change_manage:{
            show:true,
            fields:[{name:'username',type:'dict_key',title:'新管理员',dict_key:'net_manager_list'}],
            title:'转让管理员'
        },
        edit_user_buy:{
            fields: ['from_type','mapping_id','nickname', {name:'bind_status',type:'dict_tag',dict_key:'pro_bind_status'}],
            show:true,
            title:'设置用户状态'
        },
        edit_user_join:{
            fields: ['from_type','mapping_id','nickname',{name:'bind_status',type:'dict_tag',dict_key:'pro_bind_status'},'is_default'],
            show:true,
            title:'修改我的绑定信息'
        },
        change_user:{
            fields: ['net_id',{name:'old_nickname',show_type:'info'}, {name:'phone',title:'新客户号',placeholder:'支持电话号码、客户号'},'nickname'],
            show:true,
            title:'修改用户'
        },
        add_user:{
            fields: ['net_id', {name:'phone',title:'客户号:',placeholder:'支持电话号码、客户号'},{name:'nickname'}],
            show:true,
            title:'添加用户'
        },
        search: {
            fields: ['bind_status'],
        },
    }
}
